module.exports = __webpack_public_path__ + "static/media/DummyBg.8f77ca96.png";